export interface ICustomer {
  id?: string // firestore id
  email: string
  companyName: string
  companyAddress: string
  companyTel: string
  companyManager: string
  notifications: string
  status: string
  updatedAt: Date|null
}

export class Customer implements ICustomer {
  public readonly id: string
  public readonly email: string
  public readonly companyName: string
  public readonly companyAddress: string
  public readonly companyTel: string
  public readonly companyManager: string
  public readonly notifications: string
  public readonly status: string
  public readonly updatedAt: Date|null
  constructor({
    id = '',
    email = '',
    companyName = '',
    companyAddress = '',
    companyTel = '',
    companyManager = '',
    notifications = '',
    status = 'init',
    updatedAt = null
  }) {
    this.id = id
    this.email = email,
    this.companyName = companyName
    this.companyAddress = companyAddress
    this.companyTel = companyTel
    this.companyManager = companyManager
    this.notifications = notifications
    this.status = status
    this.updatedAt = updatedAt
  }

  public toObject(): ICustomer {
    return {
      id: this.id,
      email: this.email,
      companyName: this.companyName,
      companyAddress: this.companyAddress,
      companyTel: this.companyTel,
      companyManager: this.companyManager,
      notifications: this.notifications,
      status: this.status,
      updatedAt: this.updatedAt
    }
  }
}
